<div class="assignment">
    <div class="assignment__body">
        <router-outlet />
    </div>
    <div class="assignment__footer">
        <m-page-navigation [plannedAssignmentId]="getPlannedAssignmentId()" />
    </div>
</div>
